module.exports = __webpack_public_path__ + "img/item4-1.04c71bc7.png";